export class ModalContent extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  /**
   * @param {Event} event Click event triggered by clicking anywhere within the element
   */
  handleClick (event) {
    event.preventDefault()
    const triggerEl = event.target.closest(this.els?.trigger?.selector)
    if (triggerEl) {
      /* Open Trigger */
      if (triggerEl.dataset?.modalContentTriggerType === 'open') {
        this.openModal(triggerEl, triggerEl.dataset?.modalContentId)
      }

      /* Close Trigger */
      if (triggerEl.dataset?.modalContentTriggerType === 'close') {
        this.closeModal(triggerEl)
      }
    }
  }

  /**
   * @param {HTMLButtonElement} triggerEl The html button element that was clicked
   * @param {string} modalId The id of the modal to open
   */
  openModal (triggerEl, modalId) {
    if (!modalId) return
    /* Filter the trigger elements by type */
    const modalEl = this.els?.modal?.elements.find(modalEl => {
      return modalEl.dataset?.modalContentId === modalId
    })

    /* Open the modal */
    if (!modalEl) return
    modalEl.setAttribute('aria-hidden', 'false')
    triggerEl.setAttribute('aria-expanded', 'true')
  }

  /**
   * @param {HTMLButtonElement} triggerEl The html button element that was clicked
   */
  closeModal (triggerEl) {
    const modalEl = triggerEl.closest(this.els?.modal?.selector)
    modalEl.setAttribute('aria-hidden', 'true')
    triggerEl.setAttribute('aria-expanded', 'false')

    const modalId = modalEl.dataset?.modalContentId
    if (modalId) {
      const triggerEls = this.els?.trigger?.elements.filter(triggerEl => {
        return triggerEl.dataset?.modalContentId === modalId
      })

      triggerEls.forEach(triggerEl =>
        triggerEl.setAttribute('aria-expanded', 'false'),
      )
    }
  }
}

if (!customElements.get('modal-content')) {
  customElements.define('modal-content', ModalContent)
}
